(function () {
  var STORAGE_PREFIX = 'adr_favorites_';

  function getCustomerId() {
    return window.ADR_CUSTOMER_ID || null;
  }

  function storageKey() {
    var id = getCustomerId();
    return id ? STORAGE_PREFIX + id : null;
  }

  function getFavorites() {
    var key = storageKey();
    if (!key) return [];
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveFavorites(list) {
    var key = storageKey();
    if (!key) return;
    try {
      localStorage.setItem(key, JSON.stringify(list));
    } catch (e) {}
  }

  function isFavorite(id) {
    return getFavorites().some(function (p) {
      return String(p.id) === String(id);
    });
  }

  function toggleFavorite(data) {
    var key = storageKey();
    if (!key) {
      var returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = '/account/login?return_url=' + returnUrl;
      return null;
    }
    var list = getFavorites();
    var idx = list.findIndex(function (p) {
      return String(p.id) === String(data.id);
    });
    var added;
    if (idx > -1) {
      list.splice(idx, 1);
      added = false;
    } else {
      list.unshift(data);
      added = true;
    }
    saveFavorites(list);
    document.dispatchEvent(new CustomEvent('adr:favorites-changed', { detail: { list: list } }));
    return added;
  }

  function removeFavorite(id) {
    var list = getFavorites().filter(function (p) {
      return String(p.id) !== String(id);
    });
    saveFavorites(list);
    document.dispatchEvent(new CustomEvent('adr:favorites-changed', { detail: { list: list } }));
  }

  function updateButtonStates() {
    document.querySelectorAll('[data-adr-fav-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-adr-fav-id');
      var active = isFavorite(id);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.classList.toggle('is-active', active);
    });
  }

  function updateHeaderCount() {
    var count = getFavorites().length;
    document.querySelectorAll('[data-adr-fav-count]').forEach(function (el) {
      el.textContent = count > 0 ? String(count) : '';
      el.hidden = count === 0;
    });
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderFavoritesPage() {
    var container = document.querySelector('[data-adr-favorites-list]');
    if (!container) return;
    var list = getFavorites();
    var emptyState = document.querySelector('[data-adr-favorites-empty]');
    if (!list.length) {
      container.innerHTML = '';
      if (emptyState) emptyState.hidden = false;
      return;
    }
    if (emptyState) emptyState.hidden = true;
    container.innerHTML = list
      .map(function (p) {
        return (
          '<div class="adr-fav-card" data-adr-fav-card="' + escapeHtml(p.id) + '">' +
          '<a href="' + escapeHtml(p.url) + '" class="adr-fav-card__link">' +
          '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="300" height="300">' +
          '<span class="adr-fav-card__title">' + escapeHtml(p.title) + '</span>' +
          '<span class="adr-fav-card__price">' + escapeHtml(p.price) + '</span>' +
          '</a>' +
          '<button type="button" class="adr-fav-card__remove" data-adr-fav-remove="' + escapeHtml(p.id) + '" aria-label="Retirer des favoris">&times;</button>' +
          '</div>'
        );
      })
      .join('');
  }

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-adr-fav-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      var data = {
        id: toggleBtn.getAttribute('data-adr-fav-id'),
        handle: toggleBtn.getAttribute('data-adr-fav-handle'),
        title: toggleBtn.getAttribute('data-adr-fav-title'),
        image: toggleBtn.getAttribute('data-adr-fav-image'),
        price: toggleBtn.getAttribute('data-adr-fav-price'),
        url: toggleBtn.getAttribute('data-adr-fav-url')
      };
      toggleFavorite(data);
      updateButtonStates();
      updateHeaderCount();
      renderFavoritesPage();
      return;
    }
    var removeBtn = e.target.closest('[data-adr-fav-remove]');
    if (removeBtn) {
      e.preventDefault();
      removeFavorite(removeBtn.getAttribute('data-adr-fav-remove'));
      renderFavoritesPage();
      updateHeaderCount();
      updateButtonStates();
    }
  });

  function init() {
    updateButtonStates();
    updateHeaderCount();
    renderFavoritesPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('adr:favorites-changed', function () {
    updateButtonStates();
    updateHeaderCount();
  });
})();
